import { ReactNode } from "react";

import Box from "ds/components/Box";

import styles from "./styles.module.css";

type MainNavigationFooterProps = {
  children: ReactNode;
};

const MainNavigationFooter = ({ children }: MainNavigationFooterProps) => {
  return (
    <Box className={styles.navigationFooter} direction="column" gap="medium">
      {children}
    </Box>
  );
};

export default MainNavigationFooter;
